import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import React from 'react';

function StatsChartTitle({
  text,
  ...textProps
}: { text: string } & TextProps): JSX.Element {
  return (
    <Text
      color="text-light"
      mb="10px"
      textStyle={{ base: 'h4', desktop: 'h3' }}
      {...textProps}
    >
      {text}
    </Text>
  );
}

export default StatsChartTitle;
